import React, { useEffect, useState } from "react";
import {
  useAddActivity,
  useDeleteAuditor,
  useDocumentAllFiles,
  useDocumentFile,
  useGetAssessmentReports,
  useGetAuditorsListForFilters,
  UseGetRfiListForFilters,
  useGetVQAActivity,
  useGetVQAActivityBeforeAccepting,
  useGetVQARequestDetailsAdmin,
  useUpdateBackendAssessmentDetails,
  useGetAdditionalScopeOptions,
  useGetVQAParticipantsList,
  useGetJoinVQARequestDetailsAdmin,
  useConfirmAddOnScope,
  useUpdateJoinVqaScope,
} from "../../custom-hooks/queries";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { dateFormat, useUserRole, getUserType } from "../../utils/helperMethods";
import { formatActivityTimestamp } from "../../utils/utcTime";
import { selectRequestPlaceholder } from "../../utils/assessmentRequestActivityPlaceholder";
import { mergeAcceptedActivityFeed } from "../../utils/assessmentActivityFeed";
import AutocompleteTagInput from "../../components/AutocompleteTagInput";
import { Switch } from "@headlessui/react";
import UploadReportModal from "../../components/uploadReportModal";
import {
  ArrowDownTrayIcon,
  CalendarDaysIcon,
  CheckBadgeIcon,
  ChevronRightIcon,
  CurrencyDollarIcon,
  DocumentIcon,
  FolderPlusIcon,
  MapPinIcon,
  PaperClipIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import CustomTooltip from "../../components/Filters/CustomTooltip";
import { useDispatch } from "react-redux";
import { setDrawer } from "../../redux-store/features/layoutSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomButton from "../../components/CustomButton";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { sponsorContactSchema } from "../../Schema/updateSponsorContactSchema";
import { providerContactSchema } from "../../Schema/updateProviderContactSchema";
import Datepicker from "react-tailwindcss-datepicker";
import { updateAssessmentOverviewSchema } from "../../Schema/updateAssessmentOverview";
import FormModal from "../../components/FormModal";
import Notification from "../../components/Notification";
import Capabilities from "../../components/Capabilities";
import StatusProgressBar from "../../components/ProgressBar";
import CheckedDropdown from "../../components/CheckedDropdown";
import { assessmentStatusDropdown } from "../../utils/constants";
import ComboBox from "../../components/ComboBox";
import LocationFields from "../../components/LocationFields";
import { adminDetailSchema } from "../../Schema/adminDetailSchema";
import DatePickerController from "../../components/datePickerController";
import Skeleton from "react-loading-skeleton";
import AdminDetailsLoader from "../../components/Skeletons/adminDetailsLoader";
import ReportAndActivitySkeletonLoader from "../../components/Skeletons/ReportAndActivitySkeletonLoader";
import NotificationModal from "../../components/NotificationModal";
import { rest, toNumber } from "lodash";
import ServiceCategoryV2Dropdown from "../../components/ServiceCategoryV2Dropdown";
import ReportUploadDrawer from "../../components/Drawers/ReportUploadDrawer";
import JSZip from "jszip";
import { addBusinessDays, format, isValid, parseISO } from "date-fns";
import moment from "moment";
import StatusForDrawer from "../../components/StatusForDrawer";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import Modal from "../../components/Modal";
import { getVQALocationFromProvider } from "../../utils/addressUtils";
import { parseAddressComponents } from "../../utils/locationData";
import { formatCapabilitiesAsSelections } from "../../utils/foundationScope";
import {
  pickPrimaryContactsForSubmit,
  primaryContactsPayloadFromDetails,
} from "../../utils/assessmentPrimaryContactsEdit";
import JoinScopeAddOnsSection from "../../components/Assessments/JoinScopeAddOnsSection";
import AdditionalParticipatingSponsorsCell from "../../components/Assessments/AdditionalParticipatingSponsorsCell";
import { ASSESSMENT_FIELD_LABELS } from "../../utils/assessmentAdminFieldConfig";
import { applyAdminExtendedValuesOnEditEnter } from "../../utils/assessmentAdminFormHelpers";
import AssessmentAdminDatesSection from "../../components/Assessments/AssessmentAdminDatesSection";
import AssessmentAdminCapaObservationDates from "../../components/Assessments/AssessmentAdminCapaObservationDates";
import AssessmentAdminDiligentNotes from "../../components/Assessments/AssessmentAdminDiligentNotes";
import AssessmentAdminPeerReviewerField from "../../components/Assessments/AssessmentAdminPeerReviewerField";
import AssessmentAdminRequestedDraftDateRow from "../../components/Assessments/AssessmentAdminRequestedDraftDateRow";
import { useAssessmentAdminExtendedForm } from "../../custom-hooks/useAssessmentAdminExtendedForm";
import VqaOverviewContactsSection from "../../components/VqaOverviewContactsSection";
import {
  AUDITOR_REQUIRES_SCOPE_MEETING_MESSAGE,
  peerReviewerFormValueFromApi,
  peerReviewerPayloadFromForm,
  resolveExplicitAdminVqaStatus,
  shouldClearAdminSelectedStatus,
} from "../../utils/assessmentAdminStatusHelpers";
import {
  applyRequestedDraftDateOnEditEnter,
  normalizeAdminDateOnly,
  validateRequestedDraftDateChange,
} from "../../utils/assessmentAdminRequestedDraftDateHelpers";

export const BackendManageAssessment = () => {
  const { id } = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [additionalScopeTags, setAdditionalScopeTags] = useState([]);
  const userRole = useUserRole();
  const userType = getUserType(userRole);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [updateNotificationOpen, setUpdateNotificationOpen] = useState(false);
  const [allowReportToUpload, setAllowReportToUpload] = useState(false);
  const { data: rfis } = UseGetRfiListForFilters();
  const { data: scopeSuggestions } = useGetAdditionalScopeOptions();
  const locations = useLocation();

  const {
    data: vqaDetails,
    isLoading,
    refetch: vqaDetailsRefetch,
  } = useGetVQARequestDetailsAdmin(id);

  // ADO #14521: page_size 1 because only total_pending is used here.
  const { data: joinRequests } = useGetVQAParticipantsList(
    vqaDetails?.vqa?.vqa_id,
    { page_size: 1 }
  );
  const pendingJoinRequests = joinRequests?.total_pending ?? 0;

  // Sponsor-scoped Details: `?sponsor=&status=` on this SAME route
  // resolves WHICH sponsor's instance to render — every per-sponsor row on a shared
  // assessment carries the same vqa_request_id. Only fetched when a sponsor
  // param is present (id gated to undefined otherwise, per useGetVQAParticipantsList's
  // Boolean(id) enabled gate) so the originator's own Details never pays this cost.
  const [searchParams] = useSearchParams();
  const sponsorParam = searchParams.get("sponsor");
  const statusParam = searchParams.get("status");

  const { data: participantsForSponsorResolve } = useGetVQAParticipantsList(
    sponsorParam ? vqaDetails?.vqa?.vqa_id : undefined,
    { page_size: 50 }
  );
  const resolvedJoinId = sponsorParam
    ? participantsForSponsorResolve?.items?.find(
        (j) => j?.sponsor_name === sponsorParam
      )?.join_vqa_request_id ?? null
    : null;

  const {
    data: joinDetails,
    refetch: joinDetailsRefetch,
  } = useGetJoinVQARequestDetailsAdmin(resolvedJoinId, {
    enabled: !!resolvedJoinId,
  });

  const { mutate: confirmAddOnScope, isPending: isConfirmingAddOnScope } =
    useConfirmAddOnScope();
  const { mutate: updateJoinVqaScope, isPending: isSavingJoinScope } =
    useUpdateJoinVqaScope();

  // Additional Participating Sponsors mirrors the admin grid row for this same sponsor:
  // exclude by sponsor name when this Details instance is a joiner (sponsorParam set), or
  // by the primary sponsor's id for the originator's own instance (no sponsorParam).
  const primarySponsorId = vqaDetails?.vqa_request_sponsors?.find(
    (s) => s?.is_primary_sponsor
  )?.sponsor_id;
  const requestPlaceholder = selectRequestPlaceholder(vqaDetails);
  const otherParticipatingSponsors = (
    vqaDetails?.participating_sponsors || []
  ).filter((s) =>
    sponsorParam
      ? s?.sponsor_name !== sponsorParam
      : s?.sponsor_id !== primarySponsorId
  );

  const handleConfirmAddOnScope = () => {
    if (!resolvedJoinId) return;
    confirmAddOnScope(resolvedJoinId, {
      onSuccess: () => {
        joinDetailsRefetch();
        setStatus("Success");
        setMessage("Scope add-ons confirmed.");
        setUpdateNotificationOpen(true);
      },
      onError: () => {
        setMessage("Something went wrong confirming scope add-ons.");
        setUpdateNotificationOpen(true);
      },
    });
  };

  const handleSaveJoinScope = (updateJoinVqaScopeDto) => {
    if (!resolvedJoinId) return;
    updateJoinVqaScope(
      { id: resolvedJoinId, updateJoinVqaScopeDto },
      {
        onSuccess: () => {
          joinDetailsRefetch();
          setStatus("Success");
          setMessage("Scope add-ons updated.");
          setUpdateNotificationOpen(true);
        },
        onError: () => {
          setMessage("Something went wrong updating scope add-ons.");
          setUpdateNotificationOpen(true);
        },
      }
    );
  };

  const { data: auditors } = useGetAuditorsListForFilters();
  const [selectedStatus, setSelectedStatus] = useState(""); // Default selection index
  const [isSelected, setIsSelected] = useState(false); // Default selection index
  const [noCap, setNoCap] = useState(false); // Default selection index

  const optionsForMultiSelectAuditor = auditors?.map((item) => ({
    id: item?.vqa_auditor_id,
    name: item?.vqa_auditor_name,
  }));

  const { data: activityBeforeAccept, refetch: activityRefetchBeforeAccept } =
    useGetVQAActivityBeforeAccepting(vqaDetails?.vqa_request_id, {
      enabled: !!vqaDetails?.vqa_request_id, // Only enable the query when vqa_id exists
    });

  const { data: activity, refetch: activityRefetch } = useGetVQAActivity(
    vqaDetails?.vqa?.vqa_id,
    {
      enabled: !!vqaDetails?.vqa?.vqa_id, // Only enable the query when vqa_id exists
    }
  );
  const { data: allDocuments, refetch } = useGetAssessmentReports(
    vqaDetails?.vqa?.vqa_id
  );

  useEffect(() => {
    if (vqaDetails?.vqa?.vqa_id && allDocuments) {
      activityRefetch();
    }
  }, [vqaDetails, allDocuments, vqaDetails?.vqa?.vqa_id]);
  useEffect(() => {
    activityRefetchBeforeAccept();
  }, [vqaDetails]);

  const { mutate } = useAddActivity();
  const { mutate: deleteAuditor } = useDeleteAuditor();
  const {
    mutate: allFilesDownload,
    data: allFiles,
    isError: allFilesError,
  } = useDocumentAllFiles();

  const { mutate: updateBackendDetails, isError, isPending } =
    useUpdateBackendAssessmentDetails();

  const dispatch = useDispatch();
  const [comment, setComment] = useState("");

  const handleModalOpen = () => {
    setOpen(true);
  };

  const addComment = (e) => {
    mutate(
      { vqa_id: vqaDetails?.vqa?.vqa_id, comment },
      {
        onSuccess: () => {
          setComment("");
          setStatus("success");
          setMessage("Your comment has been successfully added.");
          setShow(true);
          activityRefetch();
        },
      }
    );
  };

  const handleDownloadAll = async (ids) => {
    allFilesDownload(ids); // Pass ids directly instead of using docsIds (state update is async)
  };

  useEffect(() => {
    if (allFilesError) {
      setShow(true);
      return;
    }

    if (allFiles?.length) {
      const zip = new JSZip();
      const promises = allFiles?.map((file, index) =>
        fetch(file.download_link)
          .then((res) => res.blob())
          .then((blob) => {
            const documentName =
              allDocuments?.items?.[index]?.document_name || `file_${index}`;
            zip.file(documentName, blob);
          })
      );

      Promise.all(promises).then(() => {
        zip.generateAsync({ type: "blob" }).then((zipBlob) => {
          const zipLink = document.createElement("a");
          zipLink.href = URL.createObjectURL(zipBlob);
          zipLink.setAttribute(
            "download",
            `DiligentPharmaAssessment-${
              vqaDetails?.provider?.provider_name
            }-${moment().format("YYYY-MM-DD")}.zip`
          ); // ZIP filename
          document.body.appendChild(zipLink);
          zipLink.click();
          document.body.removeChild(zipLink);
        });
      });
    }
  }, [allFiles, allFilesError]);

  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(adminDetailSchema),
    defaultValues: {
      multiSponsor: "true",
      capaNeeded: "true",
    },
  });

  const [updateActive, setUpdateActive] = useState(false);

  const {
    showIntroMeetingDatePicker,
    introMeetingReadKind,
    buildExtendedFromVqa,
    buildExtendedFromForm,
    afterSuccessfulUpdate,
    contactNotesByEmail,
    onContactNotesChange,
    sponsorContactNotesByEmail,
    onSponsorContactNotesChange,
  } = useAssessmentAdminExtendedForm({
    vqaDetails,
    setValue,
    watch,
    updateActive,
  });

  const onSucess = async (updatedStatus) => {
    const extended = buildExtendedFromVqa();
    const vqaData = {
      capabilities: vqaDetails?.capabilities,
      capaDelieveredToSponsorDate:
        vqaDetails?.vqa?.capa_delivered_to_sponsor_on,
      draftDelieveredToVendorDate:
        vqaDetails?.vqa?.draft_report_delivered_to_provider_on,
      firstAssessmentDate: vqaDetails?.vqa?.first_day_of_assessment,
      firstDraftDelieveredSponsorDate:
        vqaDetails?.vqa?.first_draft_report_delivered_to_sponsor_on,
      agreedDraftDate: vqaDetails?.vqa?.agreed_initial_draft_date,
      planningMeetingDate: vqaDetails?.vqa?.planning_meeting_completed_on,
      requestDate: vqaDetails?.desired_initial_draft_date,
      additionalDetails: vqaDetails?.additional_details,
      capaNeeded: vqaDetails?.vqa?.is_capa_needed,
      // NULL = legacy row; treat as true so a status update doesn't flip it to false
      multiSponsor: vqaDetails?.is_multi_sponsor_assessment !== false,
      providerEmail: vqaDetails?.provider?.provider_contact_email,
      providerName: vqaDetails?.provider?.provider_contact_name,
      providerPhone: vqaDetails?.provider?.provider_contact_phone,
      providerId: vqaDetails?.provider?.provider_id,
      vqaStatus: updatedStatus,
      auditorId: vqaDetails?.vqa?.auditor?.vqa_auditor_id ?? null,
      auditorName: vqaDetails?.vqa?.auditor?.vqa_auditor_name ?? null,
      ...peerReviewerPayloadFromForm(
        peerReviewerFormValueFromApi(vqaDetails?.vqa?.peer_reviewer)
      ),
      sponsors: vqaDetails?.vqa_request_sponsors,
      providerAddress: vqaDetails?.provider?.provider_address1 ?? null,
      provider_city: vqaDetails?.provider?.provider_city ?? null,
      provider_state: vqaDetails?.provider?.provider_state ?? null,
      provider_country: vqaDetails?.provider?.provider_country ?? null,
      secondaryAddress: vqaDetails?.vqa_location?.secondary_location_address ?? null,
      otherAddress: vqaDetails?.other_address ?? null,
      vqaType: vqaDetails?.vqa_type,
      introEmailDate: vqaDetails?.vqa?.intro_email_date_sent,
      ...extended,
      additional_scope: vqaDetails?.vqa?.additional_scope || null,
    };
    updateBackendDetails(
      { vqaId: vqaDetails?.vqa?.vqa_id, vqaData },
      {
        onSuccess: () => {
          setStatus("Success");
          setMessage("Assessment details have been updated successfully.");
          activityRefetch();
          reset();
          vqaDetailsRefetch();
          afterSuccessfulUpdate();
          refetch();
          setUpdateNotificationOpen(true);
        },
        onError: () => {
          setMessage("Something went wrong!");
          setUpdateNotificationOpen(true);
        },
      }
    );
  };

  const onSubmit = (data) => {
    const draftDateValidationError = validateRequestedDraftDateChange({
      originalDate: vqaDetails?.desired_initial_draft_date,
      formRequestDate: data?.requestDate,
      changeReason: data?.requestedDraftDateChangeReason,
    });
    if (draftDateValidationError) {
      setStatus("Error");
      setMessage(draftDateValidationError);
      setUpdateNotificationOpen(true);
      return;
    }

    const transformedCapabilities = data.serviceCategories?.map((service) => ({
      rfi_id: service.value,
      rfi_name: service.label,
    }));

    // Primary contacts are read-only for now — ignore any form contact values so Save
    // does not clear/overwrite them. Restore form-based mapping when re-enabling the flag.
    const primaryContacts = pickPrimaryContactsForSubmit({
      formContacts: {
        providerName: data?.providerName,
        providerEmail: data?.providerEmail,
        providerPhone: data?.providerPhone,
        sponsors: data?.sponsors,
      },
      detailsContacts: primaryContactsPayloadFromDetails(vqaDetails),
    });
    const extended = buildExtendedFromForm(data);
    const vqaData = {
      ...(noCap === false && { capabilities: transformedCapabilities }),
      capaDelieveredToSponsorDate:
        data?.capaDelieveredToSponsorDate?.startDate || null,
      draftDelieveredToVendorDate:
        data?.draftDelieveredToVendorDate?.startDate || null,
      firstAssessmentDate: data?.firstAssessmentDate?.startDate || null,
      firstDraftDelieveredSponsorDate:
        data?.firstDraftDelieveredSponsorDate?.startDate || null,
      agreedDraftDate: data?.agreedDraftDate?.startDate || null,
      planningMeetingDate: data?.planningMeetingDate?.startDate || null,
      assessmentCompletionDate:
        data?.assessmentCompletionDate?.startDate || null,
      requestDate: normalizeAdminDateOnly(data?.requestDate),
      requestedDraftDateChangeReason:
        data?.requestedDraftDateChangeReason?.trim() || null,
      additional_info: data?.additionalDetails,
      capaNeeded: data?.capaNeeded,
      multiSponsor: data?.multiSponsor,
      providerEmail: primaryContacts.providerEmail,
      providerName: primaryContacts.providerName,
      providerPhone: primaryContacts.providerPhone,
      providerId: vqaDetails?.provider?.provider_id,
      vqaStatus: resolveExplicitAdminVqaStatus(selectedStatus),
      auditorId: data?.auditors?.id ?? null,
      auditorName: data?.auditors?.name ?? null,
      ...peerReviewerPayloadFromForm(data?.peerReviewer),
      sponsors: primaryContacts.sponsors,
      // Location: use structured fields (address, city, state, country)
      providerAddress:
        data?.providerAddress !== undefined && data?.providerAddress !== ""
          ? data.providerAddress
          : vqaDetails?.provider?.provider_address1,
      provider_city:
        data?.providerCity !== undefined && data?.providerCity !== ""
          ? data.providerCity
          : vqaDetails?.provider?.provider_city ?? null,
      provider_state:
        data?.providerState !== undefined && data?.providerState !== ""
          ? data.providerState
          : vqaDetails?.provider?.provider_state ?? null,
      provider_country:
        data?.providerCountry !== undefined && data?.providerCountry !== ""
          ? data.providerCountry
          : vqaDetails?.provider?.provider_country ?? null,
      secondaryAddress:
        vqaDetails?.vqa_location?.secondary_location_address ?? null,
      otherAddress: vqaDetails?.other_address ?? null,
      vqaType:
        data?.onsiteRemote === "true"
          ? "onsite"
          : data?.onsiteRemote === "false"
            ? "remote"
            : vqaDetails?.vqa_type ?? null,
      introEmailDate: data?.introEmailDate?.startDate || null,
      ...extended,
      additional_scope: additionalScopeTags,
    };
    updateBackendDetails(
      { vqaId: vqaDetails?.vqa?.vqa_id, vqaData },
      {
        onSuccess: () => {
          setStatus("Success");
          setMessage("Assessment details have been updated successfully.");
          activityRefetch();
          // Keep multiSponsor value in sync before refetch
          setValue("multiSponsor", vqaData.multiSponsor, {
            shouldValidate: false,
          });
          reset({ multiSponsor: vqaData.multiSponsor });
          vqaDetailsRefetch();
          afterSuccessfulUpdate();
          setUpdateActive(false);
          setUpdateNotificationOpen(true);
        },
        onError: () => {
          setMessage("Something went wrong!");
          setUpdateNotificationOpen(true);
        },
      }
    );
  };

  const [drawerOpen, setDrawerOpen] = useState(false);

  const [show, setShow] = useState(false);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("success");
  const [locationAddress, setLocationAddress] = useState("");
  const [locationCity, setLocationCity] = useState("");
  const [locationState, setLocationState] = useState("");
  const [locationCountry, setLocationCountry] = useState("");
  const [countrySearch, setCountrySearch] = useState("");
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);
  const [stateSearch, setStateSearch] = useState("");
  const [autocomplete, setAutocomplete] = useState(null);

  // Disable Onsite / Remote, Observation Report Needed, and Multiple Sponsors when not in edit mode
  const areRadiosDisabled = !updateActive;

  const handleOnLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };
  const handlePlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      const { streetAddress, city, state, countryCode } =
        parseAddressComponents(place);
      setLocationAddress(streetAddress);
      setLocationCity(city);
      setLocationState(state);
      setLocationCountry(countryCode);
      setValue("providerAddress", streetAddress);
      setValue("providerCity", city);
      setValue("providerState", state);
      setValue("providerCountry", countryCode);
      setIsCountryDropdownOpen(false);
      setIsStateDropdownOpen(false);
    }
  };
  const handleChange = (e) => {
    setComment(e.target.value);
  };
  const handleDeleteAuditor = (id) => {
    deleteAuditor(id, {
      onSuccess: () => {
        setMessage("Deleted successfully");
        setStatus("success");
        setShow(true);
      },
    });
  };

  useEffect(() => {
    if (vqaDetails?.capabilities) {
      // Persist admin removals: do not re-inject Foundation - All on hydrate/edit (BUG 14475).
      setValue(
        "serviceCategories",
        formatCapabilitiesAsSelections(vqaDetails.capabilities)
      );
    }
  }, [vqaDetails, setValue]);

  useEffect(() => {
    if (vqaDetails?.vqa?.auditor?.vqa_auditor_name) {
      setValue("auditors", {
        id: vqaDetails.vqa.auditor.vqa_auditor_id,
        name: vqaDetails.vqa.auditor.vqa_auditor_name,
      });
    }
    const peerForm = peerReviewerFormValueFromApi(
      vqaDetails?.vqa?.peer_reviewer
    );
    if (peerForm) setValue("peerReviewer", peerForm);
  }, [vqaDetails, setValue]);

  useEffect(() => {
    if (updateActive && vqaDetails?.capabilities) {
      setValue(
        "serviceCategories",
        formatCapabilitiesAsSelections(vqaDetails.capabilities)
      );
    }
  }, [updateActive, vqaDetails, setValue]);

  useEffect(() => {
    setAdditionalScopeTags(vqaDetails?.vqa?.additional_scope || []);
  }, [vqaDetails]);

  const [selectedAuditor, setSelectedAuditor] = useState(""); // State for selected value
  const {
    mutate: download,

    data: files,
    isError: isFileError,
    error: errorMessageFile,
  } = useDocumentFile();

  const handleDownload = (id) => {
    download(id, {
      onSuccess: () => {
        setShow(true);
        setMessage("Downloaded Successfully");
      },
      onError: () => {
        setShow(true);
        setMessage("Download Failed");
      },
    });
  };

  useEffect(() => {
    if (isFileError) {
      setShow(true);
      return;
    }
    if (files?.download_link) {
      const link = document.createElement("a");
      link.href = files.download_link;
      link.download = "file.pdf"; // Set the filename (optional)
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [files, isFileError]);

  useEffect(() => {
    if (vqaDetails?.vqa_type) {
      setValue(
        "onsiteRemote",
        vqaDetails.vqa_type.toLowerCase() === "onsite" ? "true" : "false",
        {
          shouldValidate: true,
        }
      );
    }
  }, [vqaDetails, setValue]);

  // Initialize additionalDetails field when vqaDetails loads
  useEffect(() => {
    if (vqaDetails?.additional_details !== undefined) {
      setValue("additionalDetails", vqaDetails.additional_details || "", {
        shouldValidate: false,
      });
    }
  }, [vqaDetails?.additional_details, setValue]);

  // Sync Observation Report Needed from server when not in edit mode so display is correct
  useEffect(() => {
    if (vqaDetails?.vqa && !updateActive) {
      setValue(
        "capaNeeded",
        vqaDetails.vqa?.is_capa_needed == true ? "true" : "false",
        { shouldValidate: false }
      );
    }
  }, [vqaDetails?.vqa?.is_capa_needed, updateActive, setValue]);

  // Only set multiSponsor on initial load or reset, not on every update
  useEffect(() => {
    if (updateActive && vqaDetails) {
      setValue(
        "multiSponsor",
        // NULL = legacy row; treat as "Yes" (new requests default the flag to true)
        vqaDetails.is_multi_sponsor_assessment !== false ? "true" : "false",
        { shouldValidate: true }
      );
      if (vqaDetails?.vqa) {
        setValue(
          "capaNeeded",
          vqaDetails.vqa?.is_capa_needed == true ? "true" : "false",
          { shouldValidate: true }
        );
        applyAdminExtendedValuesOnEditEnter(setValue, vqaDetails.vqa);
        applyRequestedDraftDateOnEditEnter(
          setValue,
          vqaDetails?.desired_initial_draft_date,
          getValues("requestDate")
        );
      }
      // Set additionalDetails when entering edit mode
      setValue("additionalDetails", vqaDetails?.additional_details || "", {
        shouldValidate: true,
      });
      // Prepopulate location from vqaDetails (provider or vqa_location)
      const provider = vqaDetails?.provider;
      const addr = provider?.provider_address1 ?? "";
      const city = provider?.provider_city ?? "";
      const state = provider?.provider_state ?? "";
      const country = provider?.provider_country ?? "";
      setLocationAddress(addr);
      setLocationCity(city);
      setLocationState(state);
      setLocationCountry(country);
      setValue("providerAddress", addr, { shouldValidate: false });
      setValue("providerCity", city, { shouldValidate: false });
      setValue("providerState", state, { shouldValidate: false });
      setValue("providerCountry", country, { shouldValidate: false });
    }
  }, [updateActive, vqaDetails, setValue, getValues]);

  const agreedDraftDate = vqaDetails?.first_day_of_assessment
    ? (() => {
        const parsedDate = parseISO(vqaDetails.first_day_of_assessment); // Ensure valid date
        if (!isValid(parsedDate)) return "-"; // Handle invalid date
        return format(addBusinessDays(parsedDate, 10), "yyyy-MM-dd");
      })()
    : "-";

  useEffect(() => {
    if (shouldClearAdminSelectedStatus(vqaDetails?.vqa?.vqa_status)) {
      setSelectedStatus("");
    }
  }, [vqaDetails]);

  const handleFormSubmit = handleSubmit((data) => {
    onSubmit(data);
  });

  const handleReportAllow = () => {
    setAllowReportToUpload(true);
    setNotificationOpen(false);
    setOpen(true);
  };

  const showPopupForAuditor = () => {
    if (vqaDetails?.vqa?.planning_meeting_completed_on !== null) return;
    if (vqaDetails?.vqa?.planning_meeting_completed_on === null) {
      setMessage(
        AUDITOR_REQUIRES_SCOPE_MEETING_MESSAGE
      );
      setPopUpOpen(true);
    }
  };
  const showPopupForFirstDayOfAssessment = () => {
    if (vqaDetails?.vqa?.auditor !== null) return;
    if (vqaDetails?.vqa?.auditor === null) {
      setMessage(
        "Please select an Auditor before assigning First Day of Assessment."
      );
      setPopUpOpen(true);
    }
  };

  return (
    <div className="container">
      {isLoading ? (
        <Skeleton
          className="w-full h-32 p-7 border-y border-gray-300 bg-slate-50 mb-10"
          enableAnimation={true}
        />
      ) : (
        <div className="p-7 border-b border-gray-300 bg-slate-50 mb-10 ">
          <div className="flex items-center text-sm">
            <h1
              className="text-gray-500 cursor-pointer font-semibold"
              onClick={() => navigate("/Backend/Assessment/Request/History")}
            >
              Assessments
            </h1>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <p className="ml-5 ">
              <span className="font-semibold">
                {vqaDetails?.vqa_request_reference_number}{" "}
              </span>
              <span>{vqaDetails?.vqa?.vqa_reference_number}</span>
            </p>
          </div>
          <div className="mt-5 space-y-2 flex  flex-col justify-start items-start md:justify-between md:items-center md:flex-row">
            <div className="flex items-center">
              <span className="bg-white border border-gray-300 rounded-md px-7 py-5 mr-5">
                <CheckBadgeIcon className="h-9 w-9 text-red-500" />
              </span>

              <span>
                <p className="text-sm text-gray-500">
                  {vqaDetails?.vqa === null
                    ? vqaDetails?.provider?.provider_name
                    : vqaDetails?.vqa?.provider?.provider_name}
                </p>
                <p className="text-md font-semibold">
                  {sponsorParam ??
                    vqaDetails?.vqa_request_sponsors
                      ?.filter((sponsor) => sponsor?.is_primary_sponsor === true)
                      ?.map((item) => item?.sponsor_name)}{" "}
                </p>
                <p className="text-sm text-gray-500 ">
                  Request Date:{" "}
                  <span className="font-semibold">
                    {dateFormat(vqaDetails?.vqa_request_created_on)}
                  </span>
                </p>
              </span>
            </div>
            <div className="flex items-center justify-between md:justify-center mr-[-.5rem] gap-2">
              {!updateActive ? (
                vqaDetails?.vqa !== null &&
                vqaDetails?.vqa?.vqa_status !== "Cancelled" && (
                  <CustomButton
                    color={"bg-gray-200"}
                    size="text-base"
                    weight="font-normal"
                    height="h-9"
                    width="w-24"
                    text={"Edit"}
                    onClick={() => {
                      if (errors) {
                        setUpdateActive(true);
                      } else {
                        setUpdateActive(false);
                      }
                    }}
                  />
                )
              ) : (
                <CustomButton
                  size="text-base"
                  weight="font-normal"
                  height="h-9"
                  width="w-[5rem]"
                  textColor="text-white"
                  text={"Save"}
                  color={"bg-indigo-600"}
                  disabled={isPending}
                  loader={isPending}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit((data) => {
                      onSubmit(data);
                    })();
                  }}
                />
              )}
              {
                <CheckedDropdown
                  publishingOptions={assessmentStatusDropdown}
                  setSelectedStatus={setSelectedStatus}
                  selectedStatus={selectedStatus}
                  setUpdateActive={setUpdateActive}
                  status={
                    vqaDetails?.vqa_request_status === "Archived"
                      ? "Archived"
                      : vqaDetails?.vqa !== null
                        ? vqaDetails?.vqa?.vqa_status
                        : vqaDetails?.vqa_request_status
                  }
                  vqaId={vqaDetails?.vqa_request_id}
                  id={vqaDetails?.vqa?.vqa_id}
                  vqaDetailsRefetch={vqaDetailsRefetch}
                  docsRefetch={refetch}
                  setIsSelected={setIsSelected}
                  submit={onSucess}
                  setNoCap={setNoCap}
                  sponsors={vqaDetails?.vqa_request_sponsors}
                />
              }
            </div>
          </div>
        </div>
      )}
      <div className="mb-28 px-5 flex justify-center flex-col items-center md:justify-between md:flex-row md:items-start ">
        {isLoading ? (
          <div className="w-full md:w-[90%] border-r border-gray-300 px-3 mr-0 lg:mr-8 ">
            <AdminDetailsLoader />
          </div>
        ) : (
          <form
            className="w-full lg:w-[90%] md:w-[70%] border-r border-gray-300 px-3 mr-0 md:mr-5 lg:mr-8 "
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className=" border-b border-gray-300">
              <h1 className="font-semibold text-md pb-2">Assessment Details</h1>
            </div>
            <div className="my-5">
              <StatusProgressBar
                status={
                  vqaDetails?.vqa_request_status === "Archived"
                    ? "Archived"
                    : vqaDetails?.vqa !== null
                      ? vqaDetails?.vqa?.vqa_status
                      : vqaDetails?.vqa_request_status
                }
                vqa={vqaDetails?.vqa}
              />
            </div>
            {vqaDetails?.vqa_request_status === "Archived" ? (
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">
                  Archive Comment
                </h2>
                <p className="mt-1 text-sm text-gray-600 sm:col-span-2 sm:mt-0 italic">
                  {(vqaDetails?.archive_comment ?? "").trim() || "—"}
                </p>
              </div>
            ) : null}
            <div className="">
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">
                  {ASSESSMENT_FIELD_LABELS.onsiteRemote}
                </h2>
                <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="onsite"
                      disabled={areRadiosDisabled}
                      {...register("onsiteRemote", {
                        onChange: (e) => {
                          setValue("onsiteRemote", e.target.value, {
                            shouldValidate: true,
                          });
                          if (
                            vqaDetails?.vqa !== null &&
                            vqaDetails?.vqa?.vqa_status !==
                              "Report Published to Library" &&
                            !vqaDetails?.vqa_request_sponsors?.some((sponsor) =>
                              sponsor?.sponsor_status?.includes("Cancelled")
                            )
                          ) {
                            setUpdateActive(true);
                          }
                        },
                      })}
                      value="true"
                      checked={
                        watch("onsiteRemote") === "true" ||
                        (!watch("onsiteRemote") &&
                          vqaDetails?.vqa_type?.toLowerCase() === "onsite")
                      }
                    />

                    <label htmlFor="onsite">Onsite</label>
                  </span>
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="remote"
                      disabled={areRadiosDisabled}
                      {...register("onsiteRemote", {
                        onChange: (e) => {
                          setValue("onsiteRemote", e.target.value, {
                            shouldValidate: true,
                            shouldDirty: true,
                          });
                          if (
                            vqaDetails?.vqa !== null &&
                            vqaDetails?.vqa?.vqa_status !==
                              "Report Published to Library" &&
                            !vqaDetails?.vqa_request_sponsors?.some((sponsor) =>
                              sponsor?.sponsor_status?.includes("Cancelled")
                            )
                          ) {
                            setUpdateActive(true);
                          }
                        },
                      })}
                      value="false"
                      checked={
                        watch("onsiteRemote") === "false" ||
                        (!watch("onsiteRemote") &&
                          vqaDetails?.vqa_type?.toLowerCase() === "remote")
                      }
                    />

                    <label htmlFor="remote">Remote</label>
                  </span>
                </div>
              </div>

              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">
                  {ASSESSMENT_FIELD_LABELS.multiSponsor}
                </h2>
                <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-[6.3rem]">
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="multi-sponsor-yes"
                      value="true" // Set value as a string "true"
                      disabled={areRadiosDisabled}
                      {...register("multiSponsor", {
                        onChange: () => {
                          if (
                            vqaDetails?.vqa !== null &&
                            vqaDetails?.vqa?.vqa_status !==
                              "Report Published to Library" &&
                            !vqaDetails?.vqa_request_sponsors?.some((sponsor) =>
                              sponsor?.sponsor_status?.includes("Cancelled")
                            )
                          ) {
                            setUpdateActive(true);
                          }
                        },
                      })}
                      checked={
                        updateActive
                          ? watch("multiSponsor") === "true"
                          : vqaDetails?.is_multi_sponsor_assessment !== false
                      }
                    />
                    <label htmlFor="multi-sponsor-yes">Yes</label>
                  </span>
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="multi-sponsor-no"
                      value="false" // Set value as a string "false"
                      disabled={areRadiosDisabled}
                      {...register("multiSponsor", {
                        onChange: () => {
                          if (
                            vqaDetails?.vqa !== null &&
                            vqaDetails?.vqa?.vqa_status !==
                              "Report Published to Library" &&
                            !vqaDetails?.vqa_request_sponsors?.some((sponsor) =>
                              sponsor?.sponsor_status?.includes("Cancelled")
                            )
                          ) {
                            setUpdateActive(true);
                          }
                        },
                      })}
                      checked={
                        updateActive
                          ? watch("multiSponsor") === "false"
                          : vqaDetails?.is_multi_sponsor_assessment === false
                      }
                    />
                    <label htmlFor="multi-sponsor-no">No</label>
                  </span>
                </div>
              </div>

              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">
                  Additional Participating Sponsors
                </h2>
                <div className="mt-1 text-sm/6 sm:col-span-2 sm:mt-0 flex flex-wrap items-center gap-2">
                  {otherParticipatingSponsors.length > 0 ? (
                    <AdditionalParticipatingSponsorsCell
                      sponsors={otherParticipatingSponsors}
                      vqaRequestId={id}
                      navigate={navigate}
                    />
                  ) : (
                    pendingJoinRequests === 0 && "-"
                  )}
                  {/* ADO #14521: without this the first join request on an assessment
                      is reachable only from the notification email. Sponsor names only
                      appear once a request is approved. */}
                  {pendingJoinRequests > 0 && (
                    <button
                      type="button"
                      className="text-indigo-600 cursor-pointer hover:underline"
                      onClick={() =>
                        navigate(
                          `/Backend/AssementParticipation/${vqaDetails?.vqa?.vqa_id}/List`
                        )
                      }
                    >
                      {pendingJoinRequests} pending request
                      {pendingJoinRequests === 1 ? "" : "s"}
                    </button>
                  )}
                </div>
              </div>
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">Location </h2>
                {updateActive ? (
                  <div className="mt-1 sm:col-span-2 sm:mt-0">
                    <LocationFields
                      control={control}
                      errors={errors}
                      handleOnLoad={handleOnLoad}
                      handlePlaceChanged={handlePlaceChanged}
                      address={locationAddress}
                      setAddress={setLocationAddress}
                      city={locationCity}
                      setCity={setLocationCity}
                      state={locationState}
                      setState={setLocationState}
                      country={locationCountry}
                      setCountry={setLocationCountry}
                      countrySearch={countrySearch}
                      setCountrySearch={setCountrySearch}
                      isCountryDropdownOpen={isCountryDropdownOpen}
                      setIsCountryDropdownOpen={setIsCountryDropdownOpen}
                      isStateDropdownOpen={isStateDropdownOpen}
                      setIsStateDropdownOpen={setIsStateDropdownOpen}
                      stateSearch={stateSearch}
                      setStateSearch={setStateSearch}
                      setValue={setValue}
                      onChangeLocation={({ address, city, state, country }) => {
                        setValue("providerAddress", address);
                        setValue("providerCity", city);
                        setValue("providerState", state);
                        setValue("providerCountry", country);
                      }}
                      fieldPrefix="provider"
                      fullWidth
                    />
                  </div>
                ) : (
                  <p className="mt-1 text-sm/6 sm:col-span-2 sm:mt-0 ">
                    {(vqaDetails?.vqa_location?.is_secondary_location_required
                        ? vqaDetails?.vqa_location?.secondary_location_address
                        : null)
                      || getVQALocationFromProvider(vqaDetails?.provider, { short: false, abbvState: true })
                      || vqaDetails?.other_address
                      || ""}
                  </p>
                )}
              </div>
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">Auditor</h2>
                <p className="mt-1 text-sm/6 text-black">
                  {updateActive &&
                  allDocuments?.items?.length === 0 ? (
                    <Controller
                      name="auditors"
                      control={control}
                      value={watch("auditors")}
                      render={({ field }) => (
                        <ComboBox
                          data={optionsForMultiSelectAuditor}
                          placeHolder="Select Auditors..."
                          setSelected={(value) => {
                            setValue("auditors", value);
                          }}
                          selected={watch("auditors")}
                          width="w-full"
                          inputWidth="w-full"
                        />
                      )}
                    />
                  ) : (
                    <div onClick={() => showPopupForAuditor()}>
                      {vqaDetails?.vqa?.auditor?.vqa_auditor_name || "-"}{" "}
                    </div>
                  )}

                  <span>{errors?.auditors?.message}</span>
                </p>
              </div>
              <AssessmentAdminPeerReviewerField
                updateActive={updateActive}
                setValue={setValue}
                watch={watch}
                options={optionsForMultiSelectAuditor}
                displayName={vqaDetails?.vqa?.peer_reviewer?.vqa_auditor_name}
                errors={errors}
              />
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">Scope</h2>
                <span className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {updateActive ? (
                    <div>
                      {vqaDetails && (
                        <Controller
                          name="serviceCategories"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <ServiceCategoryV2Dropdown
                              rfiList={rfis || []}
                              placeholder="Select service categories"
                              selected={field.value || []}
                              onChange={(next) => {
                                setValue("serviceCategories", next);
                              }}
                            />
                          )}
                        />
                      )}
                      {userType === "admin" && (
                        <div className="mt-3">
                          <label className="block text-xs font-medium text-gray-700 mb-2">
                            Additional Scope
                          </label>
                          <AutocompleteTagInput
                            tags={additionalScopeTags}
                            setTags={setAdditionalScopeTags}
                            suggestions={scopeSuggestions || []}
                            placeholder="Type custom scope tags and press Enter"
                            maxTags={10}
                          />
                          <p className="mt-2 text-xs text-gray-500">
                            Add custom scope tags that don't fit the standard service categories.
                          </p>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="flex flex-wrap items-center gap-2">
                      <Capabilities
                        services={vqaDetails?.capabilities ?? []}
                        icon={true}
                        showLimited={false}
                      />
                      {additionalScopeTags?.length > 0 && (
                        <>
                          <div className="h-5 w-px bg-gray-300 mx-1" />
                          {additionalScopeTags.map((tag, index) => (
                            <span
                              key={index}
                              className="inline-flex items-center rounded-md bg-white px-2 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-300"
                            >
                              {tag}
                            </span>
                          ))}
                        </>
                      )}
                    </div>
                  )}
                </span>
              </div>
              <JoinScopeAddOnsSection
                joinDetails={joinDetails}
                isPending={statusParam === "pending"}
                isEditMode={updateActive}
                onConfirm={handleConfirmAddOnScope}
                isConfirming={isConfirmingAddOnScope}
                onSaveScope={handleSaveJoinScope}
                isSavingScope={isSavingJoinScope}
                rfiList={rfis || []}
                scopeSuggestions={scopeSuggestions || []}
              />
            </div>
            <div className="">
              <h1 className="text-lg mt-3 font-medium text-gray-900">
                Contacts
              </h1>
            </div>
            <div className="border-b border-gray-300">
              <VqaOverviewContactsSection
                userRole={userRole}
                assessmentDetails={vqaDetails}
                refetch={vqaDetailsRefetch}
                activityRefetch={
                  vqaDetails?.vqa?.vqa_id
                    ? activityRefetch
                    : activityRefetchBeforeAccept
                }
                showContactNotes={userType === "admin"}
                notesEditable={updateActive && userType === "admin"}
                vendorContactNotesByEmail={contactNotesByEmail}
                onVendorContactNotesChange={onContactNotesChange}
                sponsorContactNotesByEmail={sponsorContactNotesByEmail}
                onSponsorContactNotesChange={onSponsorContactNotesChange}
              />
            </div>
            <div className="">
              <div className="">
                <h1 className="text-lg mt-3 font-medium text-gray-900">
                  Assessment Dates
                </h1>
              </div>
              <div className="px-0 py-4">
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">Request</h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      <label htmlFor="">
                        <p className="mt-1 text-sm/6 sm:col-span-2 sm:mt-0 ">
                          {dateFormat(vqaDetails?.vqa_request_created_on)}
                        </p>
                      </label>
                    </span>
                  </p>
                </div>
              </div>
              <div
                className="px-0 py-4"
                style={{ display: vqaDetails?.vqa === null && "none" }}
              >
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    Intro Email Sent{" "}
                  </h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      <label htmlFor="">
                        {updateActive ? (
                          <DatePickerController
                            control={control}
                            fieldName={"introEmailDate"}
                            value={vqaDetails?.vqa?.intro_email_date_sent}
                            disableMinDate={true}
                          />
                        ) : vqaDetails?.vqa?.intro_email_date_sent !== null ? (
                          dateFormat(vqaDetails?.vqa?.intro_email_date_sent)
                        ) : (
                          "-"
                        )}{" "}
                      </label>
                    </span>
                  </p>
                </div>
              </div>
              <AssessmentAdminDatesSection
                vqa={vqaDetails?.vqa}
                updateActive={updateActive}
                control={control}
                dateFormat={dateFormat}
                watch={watch}
                setValue={setValue}
                showIntroMeetingDatePicker={showIntroMeetingDatePicker}
                introMeetingReadKind={introMeetingReadKind}
              >
              <div
                className="px-0 py-4"
                style={{ display: vqaDetails?.vqa === null && "none" }}
              >
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    {ASSESSMENT_FIELD_LABELS.scopePlanningMeeting}
                  </h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      <label htmlFor="">
                        {updateActive ? (
                          <DatePickerController
                            control={control}
                            fieldName={"planningMeetingDate"}
                            value={
                              vqaDetails?.vqa?.planning_meeting_completed_on
                            }
                            disableMinDate={true}
                          />
                        ) : vqaDetails?.vqa?.planning_meeting_completed_on !==
                          null ? (
                          dateFormat(
                            vqaDetails?.vqa?.planning_meeting_completed_on
                          )
                        ) : (
                          "-"
                        )}{" "}
                      </label>
                    </span>
                  </p>
                </div>
              </div>
              <div
                className="px-0 py-4"
                style={{ display: vqaDetails?.vqa === null && "none" }}
              >
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    First Day of Assessment
                  </h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      <label htmlFor="">
                        {updateActive ? (
                          <DatePickerController
                            control={control}
                            fieldName={"firstAssessmentDate"}
                            value={vqaDetails?.vqa?.first_day_of_assessment}
                            disableMinDate={true}
                          />
                        ) : (
                          <div
                            onClick={() => showPopupForFirstDayOfAssessment()}
                          >
                            {vqaDetails?.vqa?.first_day_of_assessment !==
                            null ? (
                              dateFormat(
                                vqaDetails?.vqa?.first_day_of_assessment
                              )
                            ) : (
                              <span className="cursor-pointer">-</span>
                            )}{" "}
                          </div>
                        )}{" "}
                      </label>
                    </span>
                  </p>
                </div>
              </div>

              <div
                className="px-0 py-4"
                style={{ display: vqaDetails?.vqa === null && "none" }}
              >
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    Assessment Completion
                  </h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      <label htmlFor="">
                        {updateActive ? (
                          <DatePickerController
                            control={control}
                            fieldName={"assessmentCompletionDate"}
                            value={vqaDetails?.vqa?.assessment_completion_date}
                            disableMinDate={true}
                          />
                        ) : vqaDetails?.vqa?.assessment_completion_date !== null ? (
                          dateFormat(vqaDetails?.vqa?.assessment_completion_date)
                        ) : (
                          "-"
                        )}{" "}
                      </label>
                    </span>
                  </p>
                </div>
              </div>
              <AssessmentAdminRequestedDraftDateRow
                updateActive={updateActive}
                control={control}
                register={register}
                watch={watch}
                dateFormat={dateFormat}
                desiredInitialDraftDate={vqaDetails?.desired_initial_draft_date}
                hide={vqaDetails?.vqa === null}
              />
              <div
                className="px-0 py-4"
                style={{ display: vqaDetails?.vqa === null && "none" }}
              >
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    Agreed Draft Report Date
                  </h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      <label htmlFor="">
                        {updateActive ? (
                          <DatePickerController
                            control={control}
                            fieldName={"agreedDraftDate"}
                            value={vqaDetails?.vqa?.agreed_initial_draft_date}
                            disableMinDate={true}
                          />
                        ) : vqaDetails?.vqa?.agreed_initial_draft_date !==
                          null ? (
                          dateFormat(vqaDetails?.vqa?.agreed_initial_draft_date)
                        ) : (
                          "-"
                        )}
                      </label>
                    </span>
                  </p>
                </div>
              </div>
              </AssessmentAdminDatesSection>

            </div>
            <div>
              <div style={{ display: vqaDetails?.vqa === null && "none" }}>
                <h1 className="text-lg mt-3 font-medium text-gray-900">
                  Observation Details
                </h1>
              </div>
              <div
                className="px-0 py-4"
                style={{ display: vqaDetails?.vqa === null && "none" }}
              >
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    Observation Report Needed
                  </h2>
                  <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span className="space-x-3">
                      <input
                        type="radio"
                        id="capaYes"
                        disabled={areRadiosDisabled}
                        {...register("capaNeeded", {
                          onChange: (e) => {
                            setValue("capaNeeded", e.target.value, {
                              shouldValidate: true,
                            });
                            if (
                              vqaDetails?.vqa !== null &&
                              vqaDetails?.vqa?.vqa_status !==
                                "Report Published to Library"
                            ) {
                              setUpdateActive(true);
                            }
                          },
                        })}
                        value="true"
                        checked={
                          watch("capaNeeded") == "true" ||
                          (!watch("capaNeeded") &&
                            vqaDetails?.vqa?.is_capa_needed == true)
                        }
                      />

                      <label htmlFor="capaYes">Yes</label>
                    </span>
                    <span className="space-x-3">
                      <input
                        type="radio"
                        id="capaNo"
                        disabled={areRadiosDisabled}
                        {...register("capaNeeded", {
                          onChange: (e) => {
                            setValue("capaNeeded", e.target.value, {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                            if (
                              vqaDetails?.vqa !== null &&
                              vqaDetails?.vqa?.vqa_status !==
                                "Report Published to Library" &&
                              vqaDetails?.vqa?.capa_delivered_to_sponsor_on !==
                                null
                            ) {
                              setUpdateActive(true);
                            }
                          },
                        })}
                        value="false"
                        checked={
                          watch("capaNeeded") == "false" ||
                          (!watch("capaNeeded") &&
                            vqaDetails?.vqa?.is_capa_needed == false)
                        }
                      />

                      <label htmlFor="capaNo">No</label>
                    </span>
                  </div>
                </div>
              </div>
              {watch("capaNeeded") == "true" && (
                <AssessmentAdminCapaObservationDates
                  vqa={vqaDetails?.vqa}
                  updateActive={updateActive}
                  control={control}
                  dateFormat={dateFormat}
                />
              )}
              <div className="px-0 py-4">
                <div>
                  <label
                    htmlFor="additionalDetails"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    Additional Info
                  </label>
                  <div className="mt-2">
                    {updateActive ? (
                      <textarea
                        id="additionalDetails"
                        name="additionalDetails"
                        rows={4}
                        {...register("additionalDetails", {
                          onChange: (e) => {
                            setValue("additionalDetails", e.target.value, {
                              shouldValidate: true,
                            });
                            if (
                              vqaDetails?.vqa !== null &&
                              vqaDetails?.vqa?.vqa_status !==
                                "Report Published to Library" &&
                              !vqaDetails?.vqa_request_sponsors?.some(
                                (sponsor) =>
                                  sponsor?.sponsor_status?.includes("Cancelled")
                              )
                            ) {
                              setUpdateActive(true);
                            }
                          },
                        })}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        placeholder="Enter additional information..."
                      />
                    ) : (
                      <div className="block w-full rounded-md bg-gray-50 px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 min-h-[100px] whitespace-pre-wrap">
                        {vqaDetails?.additional_details || "-"}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <AssessmentAdminDiligentNotes
                updateActive={updateActive}
                register={register}
                setValue={setValue}
                readValue={vqaDetails?.vqa?.diligent_notes}
              />
            </div>
            {updateActive &&
              vqaDetails?.vqa !== null &&
              vqaDetails?.vqa?.vqa_status !== "Cancelled" && (
                <div className="flex justify-end gap-3">
                  <CustomButton
                    size="text-base"
                    weight="font-normal"
                    height="h-9"
                    width="w-[5rem]"
                    textColor="text-black"
                    text={"Cancel"}
                    color={"bg-white"}
                    onClick={() => {
                      setUpdateActive(false);
                      reset();
                    }}
                  />
                  <CustomButton
                    size="text-base"
                    weight="font-normal"
                    height="h-9"
                    width="w-[5rem]"
                    textColor="text-white"
                    text={"Save"}
                    color={"bg-indigo-600"}
                    disabled={isPending}
                    loader={isPending}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit((data) => {
                        onSubmit(data);
                      })();
                    }}
                  />
                </div>
              )}
          </form>
        )}
        {isLoading ? (
          <ReportAndActivitySkeletonLoader />
        ) : (
          <div className="w-full md:w-[30%] mt-10 md:mt-0">
            <div className="border border-gray-300 rounded-md py-5 bg-slate-50">
              <div className="border-b border-gray-300 flex flex-col sm:flex-row flex-wrap justify-between items-stretch sm:items-center gap-3 px-3 sm:px-5 pb-2">
                <h1 className="font-semibold text-md">Reports</h1>
                {allDocuments?.items?.length > 0 && (
                  <div className="pb-2 flex-shrink-0">
                    <CustomButton
                      icon={<ArrowDownTrayIcon className="w-4 h-4" />}
                      width={
                        allDocuments?.items?.length > 1 ? "w-40" : "w-32"
                      }
                      height={"h-10"}
                      color={
                        vqaDetails?.vqa?.vqa_status === "Cancelled"
                          ? "bg-gray-400"
                          : "bg-white border border-gray-300"
                      }
                      textColor={
                        vqaDetails?.vqa?.vqa_status === "Cancelled"
                          ? "text-white"
                          : "text-gray-700"
                      }
                      text={
                        allDocuments?.items?.length > 1
                          ? `Download All (${allDocuments?.items?.length ?? 0})`
                          : "Download"
                      }
                      onClick={() => {
                        handleDownloadAll(
                          allDocuments?.items?.map((doc) => doc.document_id)
                        );
                      }}
                      disabled={vqaDetails?.vqa?.vqa_status === "Cancelled"}
                    />
                  </div>
                )}
              </div>
              {allDocuments?.items?.length === 0 ? (
                <div className="flex flex-col items-center mt-5">
                  <span className="flex justify-center items-center">
                    <FolderPlusIcon className="w-10 h-10 text-gray-300" />
                  </span>
                  <p className="mt-3 text-gray-700 text-sm font-semibold">
                    No Reports
                  </p>
                </div>
              ) : (
                <>
                  <div className="py-5 p-5">
                    {allDocuments?.items?.map((item) => (
                      <div className="flex items-center justify-between border-b border-gray-300 py-5">
                        <div className="flex items-center gap-2 pr-2">
                          <PaperClipIcon className="w-5 h-5 text-gray-500 font-semibold flex-shrink-0" />
                          <div className="flex flex-col flex-grow min-w-0">
                            <p className="text-sm font-medium break-all">
                              {item?.document_name.split(".")[0]}
                            </p>
                            <p className="text-xs font-medium mt-1 flex-shrink-0 w-max">
                              {/* ({item.document_sub_type}) */}
                              <StatusForDrawer
                                statusName={item.document_sub_type}
                                other={item?.sponsor_name}
                              />
                            </p>
                          </div>
                        </div>
                        {}
                        <button
                          className={`text-sm font-semibold text-gray-600 ${
                            vqaDetails?.vqa?.vqa_status !== "Cancelled"
                              ? "cursor-pointer"
                              : "cursor-not-allowed"
                          }`}
                          onClick={() => {
                            if (vqaDetails?.vqa?.vqa_status !== "Cancelled") {
                              handleDownload(item?.document_id);
                            }
                          }}
                          disabled={vqaDetails?.vqa?.vqa_status === "Cancelled"}
                        >
                          <ArrowDownTrayIcon className="w-8 h-8 text-gray-600 p-1" />
                        </button>
                      </div>
                    ))}
                  </div>
                </>
              )}
              <div
                className={`text-center py-2 flex justify-center px-3.5 mt-3 `}
              >
                {
                  // vqaDetails?.vqa?.vqa_status !==
                  //   "Report Published to Library" &&
                  vqaDetails?.vqa?.vqa_status !== "Cancelled" &&
                  vqaDetails?.vqa_request_status !== "Denied" &&
                  vqaDetails?.vqa_request_status !== "Cancelled" ? (
                    <CustomButton
                      width={"w-32"}
                      height={"h-10"}
                      color={"bg-indigo-600"}
                      textColor={"text-white"}
                      text={"Upload"}
                      icon={<PlusIcon className="w-5 h-5 font-semibold" />}
                      onClick={() => {
                        const currentStatus = vqaDetails?.vqa?.vqa_status;

                        const minRequiredIndex =
                          assessmentStatusDropdown.findIndex(
                            (item) => item.title === "Assessment Complete"
                          );

                        const currentIndex = assessmentStatusDropdown.findIndex(
                          (item) => item.title === currentStatus
                        );

                        if (
                          currentIndex >= minRequiredIndex ||
                          allowReportToUpload
                        ) {
                          handleModalOpen();
                        } else {
                          setStatus("Action Not Allowed!");
                          setMessage(
                            "The scheduled assessment date has not yet passed. Are you sure you would like to upload a document anyway?"
                          );
                          setNotificationOpen(true);
                        }
                      }}
                    />
                  ) : null
                }
              </div>
            </div>

            <div className="mt-10 md:mt-6">
              <h2 className="text-sm font-semibold text-gray-900">
                Assessment Activity
              </h2>
              <ul className="mt-6 space-y-6 h-80 overflow-y-auto px-2">
                {vqaDetails?.vqa === null && (
                  <ul className="relative flex flex-col gap-y-2 mt-1">
                    {activityBeforeAccept?.items
                      .sort(
                        (a, b) =>
                          new Date(b?.activity_done_on) -
                          new Date(a?.activity_done_on)
                      )
                      ?.map((item, index, array) => {
                        return (
                          <li key={index} className="relative flex gap-x-4">
                            {/* Line connecting items */}
                            {index !== array.length - 1 && (
                              <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                                <div className="w-px bg-gray-200"></div>
                              </div>
                            )}

                            {/* Circle or Profile Picture */}
                            <div className="relative flex h-6 w-6 items-center justify-center bg-white">
                              {item?.activity_comments ? (
                                <div className="h-6 w-6 rounded-full bg-gray-200 flex items-center justify-center ring-2 ring-gray-300">
                                  <span className="text-xs font-medium text-gray-700">
                                    {item?.activity_done_by
                                      ?.charAt(0)
                                      .toUpperCase() || "A"}
                                  </span>
                                </div>
                              ) : (
                                <CheckCircleIcon className="size-6 text-green-600" />
                              )}
                            </div>

                            {/* Activity Description and Comment */}
                            <div className="flex-1">
                              <p className="py-0.5 text-xs text-gray-500">
                                <span className="font-medium text-gray-900">
                                  {!item?.activity_comments &&
                                    item?.activity_done_by}
                                </span>{" "}
                                {item?.activity_description}
                              </p>

                              {item?.activity_comments && (
                                <div className="mt-2 rounded-md border border-gray-300 p-3 text-sm text-gray-800 shadow-sm w-[110%]">
                                  <div className="flex justify-between">
                                    <span className="font-medium text-gray-900 text-xs">
                                      {item?.activity_done_by}{" "}
                                      <span className="py-0.5 text-xs leading-5 text-gray-500 font-normal">
                                        commented
                                      </span>
                                    </span>
                                    <time
                                      dateTime={item?.activity_done_on}
                                      className="flex-none py-0.5 text-xs text-gray-500"
                                    >
                                      {formatActivityTimestamp(item?.activity_done_on)}
                                    </time>
                                  </div>
                                  <div className="text-gray-500 text-sm mt-2">
                                    {item?.activity_comments}
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Activity Time */}
                            {!item?.activity_comments && (
                              <time
                                dateTime={item?.activity_done_on}
                                className="flex-none py-0.5 text-xs text-gray-500"
                              >
                                {formatActivityTimestamp(item?.activity_done_on)}
                              </time>
                            )}
                          </li>
                        );
                      })}
                  </ul>
                )}
                {vqaDetails?.vqa === null && (
                  <li className="relative flex gap-x-4 mt-1">
                    {/* Line connecting items */}
                    <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                      <div className="w-px bg-gray-200"></div>
                    </div>

                    {/* Circle Indicator */}
                    <div className="relative flex h-6 w-6 items-center justify-center bg-white">
                      <div className="absolute right-0 bottom-0 text-xs text-green-500">
                        <CheckCircleIcon className="size-6 absolute right-0 bottom-0 text-green-600" />
                      </div>
                    </div>

                    {/* Report Requested Data */}
                    <div className="flex-auto flex">
                      <p className="py-0.5 text-xs text-gray-500 ">
                        <span className="font-medium text-gray-900">
                          {requestPlaceholder.actor}
                        </span>
                        <span> Requested New Assessment</span>
                      </p>

                      <time className="flex-none py-0.5 text-xs text-gray-500 ">
                        {requestPlaceholder.requestedOnLabel}
                      </time>
                    </div>
                  </li>
                )}
                {!vqaDetails?.vqa ? (
                  <li className="relative flex gap-x-4 mt-1">
                    {/* Initial request activity */}
                    {/* ... existing initial request JSX ... */}
                  </li>
                ) : activity?.items ? (
                  mergeAcceptedActivityFeed(
                    activity.items,
                    activityBeforeAccept?.items
                  ).map((item, index, array) => {
                      // Get the latest activity (most recent date)
                      const isLatest =
                        item?.activity_done_on ===
                        array.reduce((latest, current) =>
                          new Date(current?.activity_done_on) >=
                          new Date(latest?.activity_done_on)
                            ? current
                            : latest
                        )?.activity_done_on;
                      return (
                        <li key={index} className="relative flex gap-x-4">
                          {/* Line connecting items */}
                          <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                            <div className="w-px bg-gray-200"></div>
                          </div>

                          {/* Circle or Profile Picture */}
                          <div className="relative flex h-6 w-6 items-center justify-center bg-white">
                            {item?.activity_comments && !isLatest ? (
                              <div className="h-6 w-6 rounded-full bg-gray-200 flex items-center justify-center ring-2 ring-gray-300">
                                <span className="text-xs font-medium text-gray-700">
                                  {item?.activity_done_by
                                    ?.charAt(0)
                                    .toUpperCase() || "A"}
                                </span>
                              </div>
                            ) : (
                              <div className="absolute right-0 bottom-0 text-xs text-green-500">
                                <CheckCircleIcon className="size-6 absolute right-0 bottom-0 text-green-600" />
                              </div>
                            )}
                          </div>

                          {/* Activity Description and Comment */}
                          <div className="flex-[1_1_0%]">
                            <p className="py-0.5 text-xs text-gray-500">
                              <span className="font-medium text-gray-900">
                                {!item?.activity_comments &&
                                  item?.activity_done_by}
                              </span>{" "}
                              {item?.activity_description}
                            </p>
                            {item?.activity_comments && (
                              <div className="mt-2 rounded-md border border-gray-300 p-3 text-sm text-gray-800 shadow-sm w-[110%]">
                                <div className="flex justify-between">
                                  <span className="font-medium text-gray-900 text-xs">
                                    {item?.activity_done_by}{" "}
                                    <span className="py-0.5 text-xs leading-5 text-gray-500 font-normal">
                                      commented
                                    </span>
                                  </span>
                                  <time
                                    dateTime={item?.activity_done_on}
                                    className="flex-none py-0.5 text-xs text-gray-500"
                                  >
                                    {formatActivityTimestamp(item?.activity_done_on)}
                                  </time>
                                </div>
                                <div className="text-gray-500 text-sm mt-2">
                                  {item?.activity_comments}
                                </div>
                              </div>
                            )}
                          </div>

                          {/* Activity Time */}
                          <time
                            dateTime={item?.activity_done_on}
                            className="flex-none py-0.5 text-xs text-gray-500"
                          >
                            {!item?.activity_comments &&
                              formatActivityTimestamp(item?.activity_done_on)}
                          </time>
                        </li>
                      );
                    })
                ) : null}
              </ul>

              <div className="border border-gray-300 rounded-md mt-10 p-4">
                <div className="flex flex-col gap-4">
                  <textarea
                    placeholder="Add your comment..."
                    name="comment"
                    id="comment"
                    value={comment}
                    className="border-hidden overflow-hidden resize-none w-full focus:outline-none focus:border-transparent focus:ring-0 rounded-md text-sm"
                    onChange={(e) => handleChange(e)}
                  />

                  <div className="self-end">
                    <CustomButton
                      color="bg-white"
                      size="text-sm" // Adjusted size to better match button
                      weight="font-medium"
                      height="h-9"
                      width="w-24"
                      textColor="text-black"
                      text="Comment"
                      border="border border-gray-300"
                      onClick={() => addComment()}
                      disabled={!comment.trim()} // Disable button if input is empty
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <ReportUploadDrawer
          open={open}
          setOpen={setOpen}
          dataVqa={vqaDetails}
          refetch={refetch}
          activityRefetch={activityRefetch}
          vqaDetailsRefetch={vqaDetailsRefetch}
          documentType={vqaDetails?.vqa?.vqa_status}
          allDocuments={allDocuments}
          sponsors={vqaDetails?.vqa_request_sponsors}
          allowFlexibleReportTypes
        />

        {/* <FormModal open={modalOpen} setOpen={setModalOpen} /> */}

        <NotificationModal
          open={popUpOpen}
          setOpen={setPopUpOpen}
          desc={message}
          title={"Required"}
          error={true}
        />

        <Modal
          setOpen={setNotificationOpen}
          open={notificationOpen}
          description={message}
          title={"Confirm"}
          textBtn={"Yes"}
          onClick={handleReportAllow}
        />

        <Notification
          show={updateNotificationOpen}
          setShow={setUpdateNotificationOpen}
          status={isError ? "error" : "success"}
          errorMessage={message}
          // title={isError ? "Error" : status}
          // error={isError || status === "Action Not Allowed!" ? true : false}
        />
      </div>
    </div>
  );
};
